<div class="attachments-container">
  @if (imageFiles().length > 0) {
    <app-attachment-list
      [titleKey]="'attachmentUpload.sections.images'"
      [items]="imageFiles()"
      (expandItem)="btnExpandImage($event)"
      (downloadItem)="download($event)"
      (deleteItem)="onDeleteImage($event)" />
  }

  @if (documentFiles().length > 0) {
    <app-attachment-list
      [titleKey]="'attachmentUpload.sections.documents'"
      [items]="documentFiles()"
      [canDelete]="canDelete()"
      [canDownload]="canDownload()"
      (downloadItem)="download($event)"
      (deleteItem)="onDeleteDocument($event)" />
  }

  @if (showLinks() && linkFiles().length > 0) {
    <app-attachment-list
      [titleKey]="'attachmentUpload.sections.links'"
      [items]="linkFiles()"
      (deleteItem)="onDeleteLink($event)" />
  }
</div>
